import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export const getWorkspaceListApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.workspace);
    return response;
};

export const switchWorkspaceApi = async (workspaceId: string) => {
    const response = await AxiosInstance.post(apiRoutes?.switchWorkspace, { workspaceId });
    return response;
};

export const listWorkspaceMembersApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.workspaceMembers);
    return response;
};

export const listWorkspaceMembersPaginatedApi = async (data: any) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceMembersPaginated, data);
    return response;
};

export const addWorkspaceMemberApi = async (data: any) => {
    const response = await AxiosInstance.post(apiRoutes?.workspaceMembers, data);
    return response;
};

export const acceptInviteApi = async (data: any) => {
    const response = await AxiosInstance.post(apiRoutes?.acceptInvite, data);
    return response;
};

export const reinviteWorkspaceMemberApi = async (id: string) => {
    const response = await AxiosInstance.post(`${apiRoutes?.workspaceMembers}/${id}/reinvite`);
    return response;
};

export const updateWorkspaceMemberApi = async (id: string, data: any) => {
    const response = await AxiosInstance.put(`${apiRoutes?.workspaceMembers}/${id}`, data);
    return response;
};

export const deleteWorkspaceMemberApi = async (id: string) => {
    const response = await AxiosInstance.delete(`${apiRoutes?.workspaceMembers}/${id}`);
    return response;
};

export const validateInviteApi = async (data: any) => {
    const response = await AxiosInstance.post(apiRoutes?.validateInvite, data);
    return response;
};

export const listWorkspaceLocationsApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.workspaceLocations);
    return response;
};

